import { inject, Injectable } from '@angular/core';
import { AuthUser, fetchAuthSession, fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';
import { User } from '../models/auth.models';
import { Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { from, Observable, of } from 'rxjs';
import { GoAdminService } from './go-admin/go-admin.service';
import { catchError, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  router = inject(Router);
  authService = inject(AuthenticatorService);
  adminService = inject(GoAdminService);

  private currentUser: AuthUser;

  constructor() {
  }

  onAuthEvent(data) {
    console.debug('Auth Event param:', data);
    console.debug('Auth Event:', data.payload.event);
    if (data.payload.event === 'signedIn') {
      this.adminService.helper.apiKey = data.payload.data.userId;
      localStorage.setItem('x-api-key', data.payload.data.userId);
      from(getCurrentUser()).pipe(
        tap(user => this.currentUser = user),
        switchMap(user => this.adminService.getUserLabBasic$(user.signInDetails.loginId)),
        tap(lab => {
          console.debug('loaded lab', lab);
          localStorage.setItem('laboratory', JSON.stringify(lab));
        }),
        catchError(err => {
          console.error('Error during user/lab initialization', err);
          localStorage.setItem('laboratory', JSON.stringify({}));
          return of(null);
        })
      ).subscribe();

      // Add the API key to the user's attributes
      fetchUserAttributes()
      .then(attributes => {
        localStorage.setItem('user', attributes.name + ' ' + attributes.family_name);
        localStorage.setItem('email', attributes.email);
        console.debug('loaded attributes');
      })
      .catch(err => {
        console.error('Can\'t get user attributes', err);
        localStorage.clear();
        this.router.navigate(['/']);
        this.authService.signOut();
      });

      fetchAuthSession()
      .then(session => {
        const pl = session.tokens.idToken.payload;
        const user_groups = Array.isArray(pl['cognito:groups']) ? pl['cognito:groups'] : [];
        localStorage.setItem('user_groups', user_groups.toString());
        localStorage.setItem('access_token', session.tokens.accessToken.toString());
        console.debug('loaded usergroups');

      })
      .catch(err => {
        console.error('Can\'t get Auth Session.', err);
        localStorage.clear();
        this.router.navigate(['/']);
        this.authService.signOut();
      });

    }

    if (data.payload.event === 'signedOut') {
      console.log('Hub Auth event signOut');
      this.router.navigate(['/']).then(x => console.log('navigated', x));
    }
  }

  onSignout() {
    console.debug('clear localstore');

    localStorage.clear();
    this.authService.signOut();
  }

  isGranted(roleOrPermission: string, user?: User): boolean {
    try {
      const groups = localStorage.getItem('user_groups').split(',');
      return groups.includes(roleOrPermission);
    } catch (error) {
      console.error('Error checking user roles:', error);
      return false;
    }
  }

  getAccessToken(): Observable<string> {
    return from(
      fetchAuthSession().then(session => session.tokens.accessToken.toString())
    );
  }


}
